import VueRouter from "vue-router";

import { usersRoutes } from "./users";
import { authRoutes } from "./auth";
import { frontendsRoutes } from "./frontends";
import { rolesRoutes } from "./roles";
import { dashboardRoutes } from "./dashboard";
import { optionsRoutes } from "./options";
import { eventsRoutes } from "./events";
import { eventCategoriesRoutes } from "./eventCategories";
import { weekProgramsRoutes } from "./weekPrograms";

import Index from "./shared/components/template/dashboard/Index";
import PageIndex from "./shared/components/template/pages/Index";
import CourseIndex from "./shared/components/template/pages/CourseIndex";

import { AppPageNotFound, AppUnauthorized } from "./shared/components";
import Vue from "vue";

Vue.use(VueRouter);

const appRoutes = [
  {
    path: "/be",
    component: Index,
    children: [
      ...dashboardRoutes, 
      ...rolesRoutes,
      ...optionsRoutes,
      ...usersRoutes,
      ...eventsRoutes,
      ...weekProgramsRoutes,
      ...eventCategoriesRoutes
    ],
    meta: {
      auth: true
    },
  },
  {
    path: "/",
    component: CourseIndex,
    children: [...frontendsRoutes]
  },
  {
    path: "",
    component: PageIndex,
    children: [...authRoutes]
  },

  {
    path: "/403",
    name: "unauthorized",
    component: AppUnauthorized
  },
  {
    path: "*",
    name: "page-not-found",
    component: AppPageNotFound
  }
];

const routes = [...appRoutes];

export default new VueRouter({
  mode: "history",
  routes
});
